import { z } from "zod";

export type Nullable<T> = T extends z.ZodNullable<infer U> ? U : T;

export type OptionalizedNullableFields<TShape extends z.ZodRawShape> = {
  [K in keyof TShape]: TShape[K] extends z.ZodNullable<infer U>
    ? z.ZodOptional<z.ZodNullable<U>>
    : TShape[K];
};

export function makeNullableFieldsOptional<T extends z.ZodObject<z.ZodRawShape>>(
  schema: T,
): z.ZodObject<OptionalizedNullableFields<T["shape"]>> {
  const newShape = Object.entries(schema.shape).reduce(
    (acc, [key, value]) => {
      if (value.isNullable()) {
        acc[key] = value.nullish();
      } else {
        acc[key] = value;
      }
      return acc;
    },
    {} as { [key: string]: z.ZodTypeAny },
  );

  return z.object(newShape) as z.ZodObject<OptionalizedNullableFields<T["shape"]>>;
}
